import React, { Component } from 'react';
import {
  List,
  GetPurchaseOrder,
  ExportToSmartAccounts,
  UpdatePurchaseOrderStatus
} from './graphql.js';
import PurchaseOrdersComponent from '../../components/PurchaseOrders';
import {
  updateInPath,
  adminMutation,
  toAwsJson
} from '../../../../common/utils';
import { getList, getItem } from '../../../common/utils';
import { clone } from 'ramda';


export default class Teams extends Component {
  constructor() {
    super();

    this.state = { data: [], loading: false, exportStatus: false };
  }
  
  fetchData = async () => {
    this.setState(s => updateInPath(s, 'loading', true));
    const data = await getList('listPurchaseOrders', { query: List });
    this.setState(s => updateInPath(s, 'exportStatus', false));
    this.setState(s => updateInPath(s, 'data', data));
    this.setState(s => updateInPath(s, 'loading', false));
  }

  handlePurchaseOrderGet = async (purchaseOrderId, userId) => {
    return await getItem('getPurchaseOrder', {
      query: GetPurchaseOrder,
      variables: {
        purchaseOrderId: purchaseOrderId,
        userId: userId
      }
    }, ['teams']);
  }

  handleExport = async (formData) => {
    const data = clone(formData);

    data.teams = JSON.stringify(formData.teams);
    delete data.coupons;
    delete data.createdAt;
    delete data.teamIds;
    delete data.smartAccountsInvoiceNumber;
    
    adminMutation(
      data,
      [],
      ExportToSmartAccounts,
      ({exportToSmartAccounts: r}) => {
        console.log(r);
        // TODO this exportStatus is bollocks!
        if (r.errors && r.errors.length) {
          this.setState(s => updateInPath(s, 'exportStatus', 'FAILED'));
        } else {
          this.setState(s => updateInPath(s, 'exportStatus', r.invoiceNumber + " (" + r.totalAmount + " EUR)"));
        }
        this.fetchData();
      }
    );
  }

  handleModalClose = (refreshData) => {}

  componentDidMount = () => {
    this.fetchData();
  }
  
  render() {
    const { data, loading, exportStatus } = this.state;

    return (
      <PurchaseOrdersComponent
        data={data}
        loading={loading}
        onClose={this.handleModalClose}
        onExport={this.handleExport}
        exportStatus={exportStatus}
        onViewPurchaseOrder={this.handlePurchaseOrderGet}
        refresh={this.fetchData}
      />
    );
  }
}



// WEBPACK FOOTER //
// ./src/private/admin/containers/PurchaseOrders/index.js